import React from 'react';
import { Layout } from 'antd';
import { Switch, Redirect } from "react-router-dom";
import { find } from "lodash";
import { RouteWithSubRoutes } from '../../router/index';
import { Sider } from "./../../components/sider";
import Breadcrumb from "./../../components/breadcrumb";
import Header from "./../../components/header";
import Footer from "./../../components/footer";

import store from "./../../store"

import "./index.scss";

const { Content } = Layout;

interface RootPageProps {
  routes?: Array<{ name?: string }>
  location?: any
}

interface RootPageState {
  collapsed?: boolean
}

class RootPage extends React.Component<RootPageProps, RootPageState> {
  constructor(props: RootPageProps) {
    super(props);
    this.state = {
      collapsed: false
    };
    this.getStore = this.getStore.bind(this);
  }

  componentDidMount() {
    this.getStore();
  }

  getStore() {
    store.subscribe(() => {
      this.setState({
        collapsed: store.getState().common.siderCollapsed
      })
    });
  }

  render() {
    const { routes, location: { pathname } } = this.props;
    const { collapsed } = this.state;

    const currentRoute: any = find(routes, { path: pathname }) || {};
    const breadcrumbs: Array<[]> = (currentRoute.meta && currentRoute.meta.breadcrumb) || [];

    return (
      <Layout className="app ant-layout-has-sider">
        <Sider />
        <Layout className="w100p h100p">
          <Header {...this.props} />
          <Breadcrumb breadcrumbs={breadcrumbs} collapsed={collapsed} />
          <Content className={collapsed ? "layout-content collapsed" : "layout-content"}>
            <Switch>
              {routes?.map(route => {
                return <RouteWithSubRoutes key={route.name} {...route} />
              })}
              <Redirect exact from="/" to="/home" />
              <Redirect to="/404" />
            </Switch>
            <Footer />
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default RootPage;